import { ScrollAreaCorner } from './ScrollAreaCorner';
import { ScrollAreaRoot } from './ScrollAreaRoot';
import { ScrollAreaScrollbar } from './ScrollAreaScrollbar';
import { ScrollAreaViewport } from './ScrollAreaViewport';

export const ScrollArea = Object.assign(ScrollAreaRoot, {
  Viewport: ScrollAreaViewport,
  Scrollbar: ScrollAreaScrollbar,
  Corner: ScrollAreaCorner,
});
